const endpoints = {
  getPartners: 'api/v2/users/user-id/partners/',
}

export default endpoints
